import * as PIXI from "pixi.js";
import Main from "../Main";
import UILayer from "../layers/UILayer";
import { EnumEventBus, EventBus } from "../managers/EventBus";
import { ButtonStatus, Sounds } from "../types/Enum";
import BaseButton from "./buttons/BaseButton";


export default class AutoPlayCountPopup extends PIXI.Container {
  private Main = Main.getInstance();
  private UILayer = UILayer.getInstance();
  private EventBus = EventBus;
  private counts = [5, 10, 15, 20];
  private buttons: BaseButton[] = []

  constructor(coord: { x: number, y: number }, isVertical: boolean) {
    super();
    this.x = coord.x;
    this.y = isVertical ? coord.y - 10 : coord.y + 30;
    this.scale = isVertical ? 1.5 : 1;

    this.addClickableBg();
    this.addBg();
    this.counts.forEach((v, vI) => this.addButton(v, - 58 + 40 * vI, 0))
    this.setVisible(false);
    this.addToLayer();
    this.EventBus.on(EnumEventBus.setCountConVis, s => this.setVisible(Boolean(s)));
    this.EventBus.on(EnumEventBus.setAllButtonIntractvy, v => this.setButtonsInteractivityTrue(!Boolean(v)))
  }
  setButtonsInteractivityTrue(v: boolean) {
    if (!v) {
      return
    }
    for (let buttonIndex = 0; buttonIndex < this.buttons.length; buttonIndex++) {
      const button = this.buttons[buttonIndex];
      button.interactive = true;
    }
  }
  addClickableBg() {
    const dim = this.Main.getDim();
    const bg = new PIXI.Graphics()
      .rect(-this.x, -this.y, dim.width, dim.height)
      .fill({ color: 0xFFFFFF, alpha: 0 })
    bg.x = 0;
    bg.y = 0;
    bg.interactive = true;
    const handleBgFunc = () => {
      this.setVisible(false);
      this.EventBus.emit(EnumEventBus.setAllButtonIntractvy, true);
    }
    bg.on("mousedown", () => handleBgFunc());
    bg.on("touchstart", () => handleBgFunc());
    this.addChild(bg);
  }
  addButton(count: number, x: number, y: number) {
    const handleButtonSpr = () => {
      this.EventBus.emit(EnumEventBus.sendCountAmount, count);
      this.EventBus.emit(EnumEventBus.setPlayButStatus, ButtonStatus.semiOpacity);
      this.EventBus.emit(EnumEventBus.setAPlayButStatus, ButtonStatus.semiOpacity);
      this.setVisible(false);
    }
    const button = new BaseButton(count.toString(), Sounds.click3, false);
    button.width = 36;
    button.height = 36;
    button.x = x;
    button.y = y;
    button.interactive = true;
    button.cursor = "pointer";
    button.handlePress = handleButtonSpr;
    this.buttons.push(button);
    this.addChild(button)
  }
  addBg() {
    const bg = new PIXI.Graphics()
      .roundRect(-90, -25, 180, 50, 5)
      .fill({ color: 0x000000, alpha: .3 });
    this.addChild(bg);
  };
  setVisible(v: boolean) {
    this.visible = v;
  }
  addToLayer() {
    this.UILayer.addChild(this);
  }
}
